import React from 'react';

import HelpPageFooterNotice from '../components/helpPageFooterNotice';

const CreateTripGroupHelp: React.FC = () => {
  return (
    <>
      <h1>Create Trip Group</h1>

      <p>
        By default, new Trip Groups are created in your account when a new trip
        is received that contains new Trip Group lineage attributes. From the
        “Manage Trip Groups” page you can click on the “Create New Trip Group”
        link to manually create a new Trip Group in advance of a trip being
        loaded into your account.
      </p>

      <p>
        <strong>Creating a new Trip Group:</strong> To create a new Trip Group
        in your account you’ll need to provide the “Name” and “Lineage
        Attributes” in the designated fields.
      </p>

      <p>
        <strong>Name:</strong> This will be the Trip Group name that is visible
        in the Trip Center console. By default, this is typically the
        “CUSTOMER_ID” value, such as the DK#, but a more user-friendly name can
        be provided such as a corporation name, event name/date, agent team,
        etc...
      </p>

      <p>
        <strong>Lineage Attributes:</strong> These are the attributes that are
        used in the creation of the Trip Group within your account. At a
        minimum, this will include the CUSTOMER_ID value but may contain
        additional attributes depending on your account setup, such as VIP_FLAG,
        COUNTRY_ID, PCC, etc...
      </p>

      <p>
        <strong>Note:</strong> You will need to be sure that all values in the
        attributes are correct for trips to be loaded into the new Trip Group
        you’re creating. Otherwise, when we receive a trip to our system that
        does not match the attributes provided, the trip will create a new Trip
        Group that will not be associated with the Trip Group you’ve recently
        created. Please refer to your existing Trip Groups to see how attributes
        are currently being provided if you have questions.
      </p>

      <p>
        After you have added the Name and Lineage Attributes and clicked the
        “Save” button, you’ll be taken to the “EDIT TRIP GROUP” page where you
        can customize the settings for your manually created Trip Group.
      </p>

      <HelpPageFooterNotice />
    </>
  );
};
export default CreateTripGroupHelp;
